import { useAppSelector } from '@/hooks/useReduxHooks';
import { IGlobalState } from '@/store';
import { Icon } from '@successmode-ktp/kui';
import styled from 'styled-components';
import { AirportLocationGuideContent } from '@repo/components';
import { useStopScroll } from '@repo/hooks';
import { useEffect } from 'react';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  selectedAirport: string | null;
};

const AirportLocationModal = ({ isOpen, onClose, selectedAirport }: Props) => {
  const { nationality } = useAppSelector((state) => state) as IGlobalState;

  const { stopBodyScroll } = useStopScroll();

  useEffect(() => {
    stopBodyScroll(isOpen);
  }, [isOpen]);

  return (
    <>
      <Modal isOpen={isOpen}>
        <Header>
          <CloseButton onClick={onClose}>
            <Icon.X size={24} fillColor='#212121' />
          </CloseButton>
        </Header>
        <Contents>
          <AirportLocationGuideContent
            selectedAirport={selectedAirport || ''}
            nationality={nationality}
          />
        </Contents>
      </Modal>
      {isOpen && <Backdrop onClick={onClose} />}
    </>
  );
};

const Modal = styled.aside<{ isOpen: boolean }>`
  position: fixed;
  bottom: ${({ isOpen }) => (isOpen ? '0' : '-100%')};
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 16px);
  height: 90dvh;
  background-color: #fff;
  border-radius: 20px 20px 0 0;
  padding-top: 16px;
  transition: max-height 200ms;
  z-index: 200;
  overflow: hidden;
  transition: bottom 400ms;
`;

const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 24px;
  padding: 0 20px;
`;

const CloseButton = styled.button`
  width: 24px;
  height: 24px;
`;

const Contents = styled.div`
  height: calc(100% - 24px - 24px); // close button height, margin
  overflow: auto;
`;

const Backdrop = styled.aside`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000;
  opacity: 0.4;
  z-index: 100;
  overflow: hidden;
`;

export default AirportLocationModal;
